import { NgFor } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { GemSkeletonComponent } from "./gem-skeleton.component";

@Component({
  selector: "gem-skeleton-list",
  styleUrls: ["gem-skeleton-list.component.scss"],
  template: `<gem-skeleton *ngFor="let r of rowIndexes" height="1.5rem"></gem-skeleton>`,
  host: {
    role: "status",
    "aria-busy": "true",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgFor, GemSkeletonComponent],
})
export class GemSkeletonListComponent {
  rowIndexes: number[] = [];

  @Input() set rows(rows: number) {
    this.rowIndexes = Array.from({ length: rows }, (_, i) => i);
  }

  constructor() {
    this.rows = 3;
  }
}
